import { Card, Col } from "antd";
import React, { useState } from "react";
import Grid from "../../../atoms/Grid";
import DragAndDropList from "../../../atoms/Grid/gridColumnSort";
import LoaderTsx from "../../Loader.tsx";
import { useUnitGridConfig, UseUnitGridConfigOptions } from "./useUnitGridConfig";
import { useGridReset } from "../../../../hooks/useGridReset";

type UnitsGridProps = Pick<UseUnitGridConfigOptions, "actionCellRenderer"> & {
  isLoading?: boolean;
  unitStatusFilter?: string;
};

export const UnitsGrid = (props: UnitsGridProps) => {
  const { isLoading, actionCellRenderer } = props;
  const [isColumnTouched, setIsColumnTouched] = useState(false);
  const { resetGrid, setGridReset } = useGridReset();
  const { columns, gridData, setColumns, formatGridColumns } = useUnitGridConfig({
    actionCellRenderer,
    resetGrid,
    setGridReset,
  });

  const defaultSettings = {
    resizable: true,
    sortable: true,
    type: "fitCellContents",
  };


  return (
    <>
      <Col flex="none">
        <DragAndDropList
          columns={columns}
          setModifiedColumns={setColumns}
          changePicker={setIsColumnTouched}
          detectColumnChanges={isColumnTouched}
          screenName="units"
          setGridReset={setGridReset}
        />
      </Col>
      <Col span={24} className="managers_tenants_detail">
        <Card bordered={false} className="ag-nospace-body">
          {isLoading ? (
            <LoaderTsx />
          ) : (
            <Grid
              label="Units"
              data={gridData}
              columns={formatGridColumns(columns)}
              defaultSettings={defaultSettings}
              pagination={false}
              isRowSelectable={false}
              fullPage
            />
          )}
        </Card>
      </Col>
    </>
  );
};
